import {
  AdditionalBuilding,
  AdditionalBuildingType,
  AdditionalFMSBuildingType,
} from "./additionalBuildingsInterfaces";

export function mapFromFMSBuildingType(
  buildingType: string | undefined,
): string | undefined {
  switch (buildingType) {
    case AdditionalFMSBuildingType.GARAGE_ISOLATED:
    case AdditionalFMSBuildingType.GARAGE_NON_ISOLATED:
      return AdditionalBuildingType.GARAGE;
    case AdditionalFMSBuildingType.OUTHOUSE_ISOLATED:
    case AdditionalFMSBuildingType.OUTHOUSE_NON_ISOLATED:
      return AdditionalBuildingType.OUTHOUSE;
    case AdditionalFMSBuildingType.CARPORT:
      return AdditionalBuildingType.CARPORT;
    case AdditionalFMSBuildingType.ANNEX_ISOLATED:
    case AdditionalFMSBuildingType.ANNEX_NON_ISOLATED:
      return AdditionalBuildingType.ANNEX;
    case AdditionalFMSBuildingType.GARAGE_OUTHOUSE_ANNEX:
      return AdditionalBuildingType.GARAGE_OUTHOUSE_ANNEX;
    default:
      return undefined;
  }
}

export function mapToFMSBuildingType(
  building: AdditionalBuilding,
): AdditionalFMSBuildingType | undefined {
  switch (building.type) {
    case AdditionalBuildingType.GARAGE:
      return building.isolated
        ? AdditionalFMSBuildingType.GARAGE_ISOLATED
        : AdditionalFMSBuildingType.GARAGE_NON_ISOLATED;
    case AdditionalBuildingType.OUTHOUSE:
      return building.isolated
        ? AdditionalFMSBuildingType.OUTHOUSE_ISOLATED
        : AdditionalFMSBuildingType.OUTHOUSE_NON_ISOLATED;
    case AdditionalBuildingType.CARPORT:
      return AdditionalFMSBuildingType.CARPORT;
    case AdditionalBuildingType.ANNEX:
      return building.isolated
        ? AdditionalFMSBuildingType.ANNEX_ISOLATED
        : AdditionalFMSBuildingType.ANNEX_NON_ISOLATED;
    case AdditionalBuildingType.GARAGE_OUTHOUSE_ANNEX:
      return AdditionalFMSBuildingType.GARAGE_OUTHOUSE_ANNEX;
  }
  return undefined;
}

export function mapBuildingIsolation(
  buildingType: string,
): boolean | undefined {
  switch (buildingType) {
    case AdditionalFMSBuildingType.GARAGE_ISOLATED:
    case AdditionalFMSBuildingType.OUTHOUSE_ISOLATED:
    case AdditionalFMSBuildingType.ANNEX_ISOLATED:
      return true;
    case AdditionalFMSBuildingType.GARAGE_NON_ISOLATED:
    case AdditionalFMSBuildingType.OUTHOUSE_NON_ISOLATED:
    case AdditionalFMSBuildingType.ANNEX_NON_ISOLATED:
      return false;
  }
  return undefined;
}
